import { Box, BoxProps, TableFooter, TablePagination } from "@mui/material";
import { QueryResponse } from "@/shared/types/base";
import usePagination from "../hooks/use-pagination";
import { UseQueryResult } from "@tanstack/react-query";
import { useFiltersReturn } from "@/components/filters";

export interface DataTablePagionationProps extends BoxProps {
    filterData?: useFiltersReturn,
    queryResult?: UseQueryResult<QueryResponse<any>>
    rowsPerPageOptions?: number[]
};

export default function DataTablePagination({
    filterData,
    queryResult,
    rowsPerPageOptions = [10, 25, 50, 100],
    ...props
}: DataTablePagionationProps) {
    const { page, pageSize, count, setPagination } = usePagination({ filterData, queryResult });

    const getPageSizeOptions = () => {
        if (pageSize < 0)
            return [...rowsPerPageOptions, { value: pageSize, label: "Todos" }];
        if (!rowsPerPageOptions.includes(pageSize))
            return [...rowsPerPageOptions, { value: pageSize, label: "Custom" }];
        return rowsPerPageOptions;
    }

    const getPageLabel = ({ count, from, to }: { count: number, from: number, to: number }) => {
        if (queryResult?.error) return "Error";
        if (count < 0) return "Cargando...";
        if (count === 0) return "Vacío";
        if (pageSize <= 0) return "Todos";
        return `${from}-${to} de ${count}`;
    }

    return <TableFooter component={Box} zIndex={10} bgcolor={"background.default"} {...props}>
        <TablePagination
            sx={{ overflowX: "clip" }}
            component={Box}

            count={count}
            page={page}
            rowsPerPage={pageSize}

            onPageChange={(_, value) => setPagination(value)}
            onRowsPerPageChange={(e) => setPagination(0, Number(e.target.value))}

            rowsPerPageOptions={getPageSizeOptions()}

            labelRowsPerPage={"Items por página: "}
            labelDisplayedRows={getPageLabel}

            showFirstButton
            showLastButton
        />
    </TableFooter>
}